import { customElement } from "lit/decorators.js";
import { html } from "lit";
import { ref } from "lit/directives/ref.js";
import { Task } from "@lit/task";
import { createClearAuth } from "./storage/clearAuth";
import { MenuBaseElement, MenuBaseElementProps } from "./MenuBaseElement";
import { domainsPromise } from "./domains";

export type M2MUserMenuProps = MenuBaseElementProps;

@customElement("m2m-user-menu")
export class M2MUserMenu extends MenuBaseElement {
  handleLogout = async () => {
    await createClearAuth()();
    window.location.reload();
  };
  private _usersUrlTask = new Task(this, {
    task: async (_: unknown, { signal }) => {
      const domains = await domainsPromise(signal);
      return domains.users;
    },
    args: () => [],
  });

  render() {
    const additionalItems = this.additinalItems?.map((item) => {
      return html`
        <li>
          <a href="${item.href}">${item.label}</a>
        </li>
      `;
    });
    const isHidden = this.expanded === false || this.expanded === undefined;
    return html`<nav>
      <button
        type="button"
        class="navigation-drawer-controll-button navigation-drawer-controll-button--icon"
        aria-controls="m2m-user-menu__navigation-drawer"
        aria-expanded=${this.expanded}
        @click=${this.handleToggleDrawer}
      >
        <svg viewBox="0 0 24 24" width="38px" height="38px" fill="#000000">
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
          />
        </svg>
      </button>
      <ul
        ${ref(this.listRef)}
        id="m2m-user-menu__navigation-drawer"
        aria-hidden=${isHidden}
        class="navigation-drawer"
      >
        <li>
          ${this._usersUrlTask.render({
            pending: () => html`<a disabled href="#">Loading...</a>`,
            complete: (usersUrl) => {
              return html`<a href="${usersUrl}">アカウント情報</a>`;
            },
          })}
        </li>
        <li @click=${this.handleLogout}>
          <button type="button">ログアウト</button>
        </li>
        ${additionalItems}
      </ul>
    </nav>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "m2m-user-menu": M2MUserMenu;
  }
}
